import { ConfigCatProvider, createFlagOverridesFromQueryParams, OverrideBehaviour, PollingMode } from 'configcat-react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { ErrorBoundary } from './components/ErrorBoundary';
import { config } from './config';
import { main } from './configuration';
import { handleLoginRedirect } from './configuration/login/redirect';
import { store } from './configuration/setup/store';
import { router } from './routes/Router';

const renderApplication = () => {
    createRoot(document.getElementById('root') as HTMLElement).render(
        <ErrorBoundary>
            <Provider store={store}>
                <ConfigCatProvider
                    sdkKey={config.configCat.apiKey}
                    pollingMode={PollingMode.AutoPoll}
                    options={{
                        cacheTimeToLiveSeconds: 60,
                        flagOverrides: createFlagOverridesFromQueryParams(OverrideBehaviour.LocalOverRemote),
                    }}
                >
                    <RouterProvider router={router} />
                </ConfigCatProvider>
            </Provider>
        </ErrorBoundary>
    );
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

if ((isDev && config.enableMockServer) || isProdPreview) {
    import('../mocks/serviceMock').then(({ worker }) => {
        // The app can still render when the optional mock worker cannot register.
        worker
            .start()
            .catch(() => undefined)
            .finally(() => main(renderApplication));
    });
}

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect();
} else if (isProd && !isProdPreview) {
    main(renderApplication);
}
